import React, { FC } from 'react'
import AddNoteModal, { openAddNoteModal } from './AddNoteModal'
import DeleteNoteModal, { openDeleteNoteModal } from './DeleteNoteModal'
import { linkedFile, note } from '../../types'

const Modals: FC<{
  ID: string
  hash: string
  selected: note
  linkedfiles: linkedFile[]
  onRefresh: () => void
}> = ({ ID, hash, selected, linkedfiles, onRefresh }) => (
  <div>
    {/* @ts-ignore */}
    <AddNoteModal ID={ID} hash={hash} linkedfiles={linkedfiles} selected={selected} onRefresh={onRefresh} />
    <DeleteNoteModal onRefresh={onRefresh} />
  </div>
)

export { openAddNoteModal, openDeleteNoteModal }

export default Modals
